<template>
  <v-card class="mb-8">
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.commons.filters.title") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-show="view.elem.datatable.visible" class="py-0">
      <v-layout row wrap>
        <v-flex md12>
          <filters ref="filters" @filter="filter" @email="email" />
        </v-flex>
        <v-flex md12>
          <v-data-table
            ref="dataTable"
            item-key="clave"
            class="base dataTable"
            sort-by="clave"
            :show-select="$userPermission.hasPermission('ROLE_ACCESO_ENVIAR_EMAILB')"
            :sort-desc="true"
            :headers="view.elem.datatable.headers"
            :items="view.elem.datatable.data"
            :loading="view.elem.datatable.loading"
            :footer-props="view.elem.datatable.footerprops"
            :must-sort="true"
            :server-items-length="view.elem.datatable.total"
            :options.sync="options"
            :value="selected"
            @toggle-select-all="toggleSelectAll"
            @item-selected="itemSelected">
            <template #top>
              <v-text-field
                v-model.trim="search"
                dense
                clearable
                hide-details
                :label="$t('view.commons.search')"
                append-icon="mdi-magnify"
                @keydown.enter="refreshSearch"
                @click:append="refreshSearch"
                @click:clear="clearSearch" />
            </template>

            <template #footer.prepend>
              <v-navigation-drawer v-if="selectedcomputed">{{ selectedcomputed }} {{ $t("view.commons.selected") }}</v-navigation-drawer>
            </template>

            <template #item.data-table-select="{ item, isSelected, select }">
              <v-checkbox :input-value="isNotSelectable(item) ? false : isSelected" :disabled="isNotSelectable(item)" hide-details class="pa-0 ma-0" @click="select(!isSelected)" />
            </template>

            <template #item.clave="{ item }">
              {{ item.clave }}
            </template>

            <template #item.fechaalta="{ item }">
              {{ formatDateTime(item.fechaalta) }}
            </template>

            <template #item.accion="{ item }">
              <buttonCustom
                :ref="`dataTableBtnDetalle_${item.clave}`"
                :paramtype="'Object'"
                :paramobj="item"
                :showcustom="$userPermission.hasPermission('ROLE_ACCESO_BASE') && item.tipoCode != 'F'"
                action="detail"
                icon="fas fa-search"
                :title="$t('view.commons.detail')"
                @detail="detail(item)" />

              <buttonDisable
                :ref="`dataTableBtnDisable_${item.clave}`"
                :clave="item.clave"
                :showdisable="item.status != 'CANCELADO'"
                :isdelete="true"
                :loading="loading.includes(item.clave)"
                :clase="loading.length > 0 ? 'loading' : ''"
                @disable="disable" />

              <buttonDownload
                v-if="item.idFileTransaction"
                :ref="`dataTableBtnDownload_${item.idFileTransaction}`"
                :clave="item.idFileTransaction"
                :loading="loading.includes(item.idFileTransaction)"
                :clase="loading.length > 0 ? 'loading' : ''"
                @download="download" />

              <buttonAudit
                :ref="`btnAudit_${item.clave}`"
                :clave="item.clave"
                :clase="loading.length > 0 ? 'loading' : ''"
                :descripcion="item.nombreArchivo"
                :showaudit="$userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                :loading="loading.includes(item.clave)"
                @audit="audit" />
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
    <auditoria ref="auditModal" />
  </v-card>
</template>
<script>
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import Filters from "@/views/bases/base/Filters"; /** *******************************/
import BaseAPI from "@/services/bases/base"; /** *******************************/
import FileTransactionAPI from "@/services/filetransaction/importer"; /** *******************************/
import ButtonCustom from "@/components/datatable/ButtonCustom"; /** *******************************/
import ButtonDisable from "@/components/datatable/ButtonDisable"; /** *******************************/
import ButtonDownload from "@/components/datatable/ButtonDownload"; /** *******************************/
import ButtonAudit from "@/components/datatable/ButtonAudit"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { deleteSwal, emailSendSwal } from "@/constants/sweet-alerts";
import { formatDateTime } from "@/helpers/date-methods";
import { handleResponse } from "@/helpers/http-response-handler";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

export default {
  name: "DataTable"
  , components: {
    Filters
    , ButtonCustom
    , ButtonDisable
    , ButtonDownload
    , ButtonAudit
    , Auditoria
  }
  , data() {
    return {
      options: {}
      , filtros: {}
      , selected: []
      , deselected: []
      , loading: []
      , selectedCount: 0
      , selectall: false
      , search: ""
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.commons.clave"), align: "left", sortable: true, class: "tablaHeader clave", value: "clave" }
              , { text: this.$t("view.bases.base.tabla.idFileTransaction"), align: "left", sortable: true, class: "tablaHeader idFileTransaction", value: "idFileTransaction" }
              , { text: this.$t("view.bases.base.tabla.fechaRegistro"), align: "left", sortable: true, class: "tablaHeader fechaalta", value: "fechaalta" }
              , { text: this.$t("view.bases.base.tabla.nombreArchivo"), align: "left", sortable: true, class: "tablaHeader nombreArchivo", value: "nombreArchivo" }
              , { text: this.$t("view.bases.base.tabla.tipo"), align: "left", sortable: true, class: "tablaHeader", value: "tipo" }
              , { text: this.$t("view.bases.base.tabla.vendor"), align: "left", sortable: true, class: "tablaHeader", value: "vendor" }
              , { text: this.$t("view.bases.base.tabla.cantidadRegistros"), align: "center", sortable: true, class: "tablaHeader", value: "cantidadRegistros" }
              , { text: this.$t("view.bases.base.tabla.status"), align: "left", sortable: true, class: "tablaHeader status", value: "status" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "tablaHeader", value: "accion", width: "200px" }
            ]
          }
        }
      }
    };
  }
  , computed: {
    selectedcomputed() {
      if (this.selectall) return this.deselected ? this.selectedCount - this.deselected.length : this.selectedCount;
      return this.selected ? this.selected.length : 0;
    }
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData(filtros = this.filtros) {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      filtros.foremail = "true";

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await BaseAPI.list(serverSideDataT);
      const { data, recordsTotal, todasLasClaves } = response.data;

      this.view.elem.datatable.data = data;
      this.selectedCount = todasLasClaves.length;
      if (this.selectall) this.selected = data.filter((item) => !this.deselected.filter((i) => i.clave == item.clave));
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , refreshData() {
      this.clearSelection();
      this.load();
    }
    , refreshSearch() {
      this.options.page = 1;
      this.clearSelection();
      this.load();
    }
    , clearSearch() {
      this.search = "";
      this.options.page = 1;
      this.clearSelection();
      this.load();
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.options.page = 1;
      this.filtros = fls;
      this.clearSelection();
      await this.load();
    }
    , async detail(item) {
      this.$emit("detail", item.tipo, item.clave);
    }
    , async disable(clave) {
      if ((await this.$swal(deleteSwal)).value) {
        if (!this.loading.includes(clave)) this.loading.push(clave);
        this.load();
        const response = await BaseAPI.disable({ clave });
        this.loading = this.loading.filter(function (value) {
          return value != clave;
        });
        if (handleResponse(response)) this.load();
      }
    }
    , async download(clave) {
      if (!this.loading.includes(clave)) this.loading.push(clave);
      this.load();
      const response = await FileTransactionAPI.download(clave);
      const url = globalThis.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.headers.filename); // or any other extension
      document.body.appendChild(link);
      link.click();
      this.loading = this.loading.filter(function (value) {
        return value != clave;
      });
      this.load();
    }
    , async audit(clave, descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TBase", descripcion, "Bases");
    }
    , itemSelected({ item, value }) {
      if (value) {
        if (!this.selected.some((i) => i.clave == item.clave)) this.selected.push(item);
        this.deselected = this.deselected.filter((i) => i.clave != item.clave);
      } else {
        this.selected = this.selected.filter((i) => i.clave != item.clave);
        if (!this.deselected.some((i) => i.clave == item.clave)) this.deselected.push(item);
      }
    }
    , toggleSelectAll({ value }) {
      this.selectall = value;
      if (value) {
        this.selected = this.view.elem.datatable.data;
        this.deselected = [];
      } else {
        this.selected = [];
        this.deselected = this.view.elem.datatable.data;
      }
    }
    , clearSelection() {
      this.selectall = false;
      this.selected = [];
      this.deselected = [];
    }
    , async email() {
      const filters = { ...this.filtros };

      console.log(this.selectall ? this.selectedCount - this.deselected.length : this.selected.length);

      if (this.selectedCount <= 0 || (!this.selectall && this.selected.length <= 0)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "info", "VL0000", this.$t("view.commons.minselregs"));
        return false;
      }

      if ((this.selectall && this.selectedCount - this.deselected.length > 1000) || this.selected.length > 1000) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "info", "VL0000", this.$t("view.commons.maxregs"));
        return false;
      }

      if (this.selectall) {
        if (this.deselected && this.deselected.length > 0) filters.deselected = this.deselected.map((i) => i.clave).join(",");
      } else {
        filters.selected = this.selected.map((i) => i.clave).join(",");
      }

      const serverSideDataT = this.prepareData(filters);
      const response = await BaseAPI.email(serverSideDataT);

      if (response && response.data && response.data.data && response.data.data.length > 0) {
        this.refreshData();

        setTimeout(async () => {
          document.body.click();
          let { total, totalError, totalOk, totalUpdate, duration } = response.data.data[0];

          let error = "";

          if (totalError > 0 || totalOk - totalUpdate == total) {
            emailSendSwal.type = "warning";

            if (duration.includes("|")) {
              let errors = duration.split("|");
              duration = errors.pop(); // Get duration
              error = "<br><br><ul style='list-style: none; font-weight: 500;'>";
              errors.forEach((elem) => {
                error += `<li>${elem}</li>`;
              });
              error += "</ul>";
            }
          }

          emailSendSwal.html = `
              Registros seleccionados:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${total}</b><br>
              Archivos enviados por email:&nbsp;&nbsp;<b>${totalUpdate}</b><br>
              Archivos no enviados:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${totalOk - totalUpdate}</b><br>
              Errores al enviar por email:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${totalError}</b><br><br>
              Duración:&nbsp;<b>${duration}</b>${error}`;

          if (!(await this.$swal(emailSendSwal)).value) return true;
        }, 500);
      } else {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "MS8001", this.$t("view.bases.base.error.MS8000"));
      }
    }
    , isNotSelectable(item) {
      return !item.vendor || item.tipoCode == "E" || !["PENDIENTE", "ENVIADA"].includes(item.status);
    }
    , formatDateTime
  }
};
</script>

<style>
.base .clave {
  width: 80px !important;
  min-width: 80px !important;
  padding-left: 0 !important;
}

.base .idFileTransaction {
  width: 130px !important;
  min-width: 130px !important;
}

.base .fechaalta {
  width: 210px !important;
  min-width: 210px !important;
}

.base .nombreArchivo {
  min-width: 300px !important;
}

.base .accion {
  width: 180px !important;
  min-width: 180px !important;
}

.base .status {
  width: 130px !important;
  min-width: 130px !important;
}

.base .theme--light.v-input--is-disabled,
.base .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.171);
}
</style>



// WEBPACK FOOTER //
// src/views/bases/base/DataTable.vue